import script from "./SectionHowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionHowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./SectionHowItWorks.vue?vue&type=style&index=0&id=e2314c46&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2314c46"]])

export default __exports__